"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ChartRadarSolid: function() {
        return ChartRadarSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ChartRadarSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M9.94617 12.517C9.94262 12.5027 9.9389 12.4884 9.93503 12.4741L12.4862 9.92296L12.5061 9.92805L13.5391 13.5436L9.94617 12.517Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M1.12584 11.5144C0.958052 11.8164 0.958053 12.1836 1.12584 12.4857L6.12584 21.4856C6.30221 21.8031 6.63683 22 7 22H17C17.3632 22 17.6978 21.8031 17.8742 21.4856L22.8742 12.4857C23.0419 12.1836 23.0419 11.8164 22.8742 11.5144L17.8742 2.51436C17.6978 2.19689 17.3632 2 17 2H7C6.63683 2 6.30221 2.19689 6.12584 2.51436L1.12584 11.5144ZM10.9951 7.98828C10.9951 6.88371 11.8905 5.98828 12.9951 5.98828C14.0997 5.98828 14.9951 6.88371 14.9951 7.98828C14.9951 8.53 14.7797 9.02142 14.4299 9.38157L15.4783 13.0509C16.3536 13.264 17.0034 14.0532 17.0034 14.9941C17.0034 16.0987 16.108 16.9941 15.0034 16.9941C14.0693 16.9941 13.2848 16.3538 13.0649 15.4881L9.39367 14.4392C9.03393 14.7864 8.54435 15 8.00488 15C6.90031 15 6.00488 14.1046 6.00488 13C6.00488 11.8954 6.90031 11 8.00488 11C8.18121 11 8.35221 11.0228 8.51509 11.0657L11.0653 8.51543C11.0195 8.34748 10.9951 8.17074 10.9951 7.98828Z",
            fill: "currentColor"
        })
    ]
}), "ChartRadarSolid");
const _default = ChartRadarSolid;
